import NCustomForm from './NCustomForm.vue';

export default NCustomForm;